import { DeleteOutlined, DownloadOutlined, EditOutlined, PlusOutlined, PrinterOutlined, SaveOutlined, UploadOutlined, ArrowLeftOutlined, CheckOutlined, FileExcelOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, DatePicker, DatePickerProps, Form, Input, Modal, Row, Select, Space, Table, Tabs, Tag, Tooltip } from 'antd';
import { useForm } from 'antd/es/form/Form';
import Column from 'antd/es/table/Column';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { ContentHeader } from "../../../components";
import ModalTextForm from '../../../components/modal/ModalTextForm';
import { Links } from '../../../helpers/Links';
import { menuHelper } from '../../../helpers/account';
import { arrayCommon, currencyFormat, dateCommon, formatVND, layTenNhomNhanSu, roundToInt, validateMessages } from '../../../helpers/common';
import { ImportFileLPS, NhanVien_MucLuong_PhuCap } from '../../../models/luong/Luong';
import { XuatExcelLuongPhatSinh, importFileCongDoanPhi, layChiTietKhenThuongUngHo, layDuLieuNhanVienVaMucLuong_Cong_PhuCap, layMauLuongPhatSinh, luuKhenThuongUngHo, xoaLuongKhenThuongUngHo } from '../../../services/luong';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import DanhSachMucLuongVaPhuCapTheoNhanVienTableModal from '../DanhSachMucLuongVaPhuCapTheoNhanVienTableModal';
import InChiTietKhenThuongUngHo from '../InChiTietKhenThuongUngHo';
import DinhKemFilePDF from '../components/DinhKemFilePDF';

// Loai cach tinh co dinh la Cong doan phi (value=2)
const LOAI_CONG_DOAN_PHI = 2;

var optionsLoaiKTUH = [
    { value: 0, label: "Giảm trừ thu nhập" },
    { value: 1, label: "Thu nhập bổ sung" }
];

const PrintPage = styled.div`
  @media print {
    @page {
      size:landscape;
      background-color: white;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
  }
`;

const CongDoanPhi = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.Luong.CongDoanPhi,
        Links.Luong.ChiTietCongDoanPhi]);
    const [form] = useForm();
    const [idKTUH, setIdKTUH] = useState<number>(0);
    const [trangThai, setTrangThai] = useState<number>(-1);
    const [isDisable, setIsDisable] = useState(false);
    const [isShowError, setIsShowError] = useState(false);
    const [isEffect, setIsEffect] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loaiKTUH, setLoaiKTUH] = useState<number>(0);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [showModalDSNV, setShowModalDSNV] = useState(false);
    const [dsNhanVien, setDsNhanVien] = useState<Array<NhanVien_MucLuong_PhuCap>>([]);
    const [dataModalNV, setDataModalNV] = useState<Array<NhanVien_MucLuong_PhuCap>>([]);
    const [editingNV, setEditingNV] = useState<NhanVien_MucLuong_PhuCap>(new NhanVien_MucLuong_PhuCap);
    const [isEdditing, setIsEdditing] = useState(false);
    const [rowIndex, setRowIndex] = useState(-1);
    const [thangNam, setThangNam] = useState<Date>(new Date);
    const [titleIn, setTitleIn] = useState<String>("");
    const [ghiChu, setGhiChu] = useState<string>("");
    const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
    const [showModalXacNhan, setShowModalXacNhan] = useState<boolean>(false);
    const [reloadPage, setReloadPage] = useState(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [file, setFile] = useState<any>();
    const [formNV] = Form.useForm();

    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    type FieldKPICaNhan = {
        "thangNam": Date;
    };

    const componentRef = useRef(null);
    const printLuong = useReactToPrint({
        content: () => componentRef.current,
    });

    const onChangeDanhSachNhanVienTableModal = (data: NhanVien_MucLuong_PhuCap, isChecked: boolean) => {
        var tempData = [...dsNhanVien];
        var isExists = arrayCommon.isExisted(dsNhanVien.map(x => x.idNhanVien), data.idNhanVien);
        if (isChecked && !isExists) {
            var rowTotalNhomNS = tempData.find(x => x.idNhanVien == 0 && x.idNhom == data.idNhom);
            if (rowTotalNhomNS != undefined) {
                let index = tempData.map(x => x.idNhom).indexOf(data.idNhom);
                tempData.splice(index + 1, 0, data);
            }
            else {
                if (data.idNhom == 3) {
                    tempData.unshift(data);
                    let newRowTotal = new NhanVien_MucLuong_PhuCap();
                    let dsTheoNNS = tempData.filter(x => x.idNhom === data.idNhom && x.idNhanVien != 0);
                    newRowTotal.id = 0;
                    newRowTotal.idNhanVien = 0;
                    newRowTotal.idNhom = data.idNhom;
                    newRowTotal.mucLuongBHXH = dsTheoNNS.reduce((total, currentValue) => total + currentValue.mucLuongBHXH, 0);
                    newRowTotal.mucThuNhap = dsTheoNNS.reduce((total, currentValue) => total + currentValue.mucThuNhap, 0);
                    newRowTotal.phuCapChucVu = dsTheoNNS.reduce((total, currentValue) => total + currentValue.phuCapChucVu, 0);
                    newRowTotal.hoTen = layTenNhomNhanSu(data.idNhom);
                    newRowTotal.tenChucVu = "";
                    newRowTotal.tenDonVi = "";
                    newRowTotal.maNhanVien = "";
                    newRowTotal.ghiChu = "";
                    tempData.unshift(newRowTotal);
                }
                else {
                    let newRowTotal = new NhanVien_MucLuong_PhuCap();
                    let dsTheoNNS = tempData.filter(x => x.idNhom === data.idNhom && x.idNhanVien != 0);
                    newRowTotal.id = 0;
                    newRowTotal.idNhanVien = 0;
                    newRowTotal.idNhom = data.idNhom;
                    newRowTotal.mucLuongBHXH = dsTheoNNS.reduce((total, currentValue) => total + currentValue.mucLuongBHXH, 0);
                    newRowTotal.mucThuNhap = dsTheoNNS.reduce((total, currentValue) => total + currentValue.mucThuNhap, 0);
                    newRowTotal.phuCapChucVu = dsTheoNNS.reduce((total, currentValue) => total + currentValue.phuCapChucVu, 0);
                    newRowTotal.hoTen = layTenNhomNhanSu(data.idNhom);
                    newRowTotal.tenChucVu = "";
                    newRowTotal.tenDonVi = "";
                    newRowTotal.maNhanVien = "";
                    newRowTotal.ghiChu = "";
                    tempData.push(newRowTotal);
                    tempData.push(data);
                }
            };
        }
        if (!isChecked && isExists) {
            var index = tempData.map(x => x.idNhanVien).indexOf(data.idNhanVien);
            if (index > -1) {
                tempData.splice(index, 1);
            }
        }
        if (tempData.find(x => x.idNhom == data.idNhom && x.idNhanVien != 0) == undefined) {
            let totalNNS = tempData.find(x => x.idNhanVien == 0 && x.idNhom == data.idNhom);
            if (totalNNS != undefined) {
                tempData.indexOf(totalNNS, 0) > -1 ? tempData.splice(tempData.indexOf(totalNNS, 0), 1) : null;
            }
        }
        else {
            let totalNNS = tempData.find(x => x.idNhanVien == 0 && x.idNhom == data.idNhom);
            if (totalNNS != undefined) {
                let dsTheoNNS = tempData.filter(x => x.idNhom === data.idNhom && x.idNhanVien != 0);
                totalNNS.mucLuongBHXH = dsTheoNNS.reduce((total, currentValue) => total + currentValue.mucLuongBHXH, 0);
                totalNNS.phuCapChucVu = dsTheoNNS.reduce((total, currentValue) => total + currentValue.phuCapChucVu, 0);
            }
        }
        if (isEffect) {
            onChangeMucTien(isEffect, tempData);
        }
        else {
            setDsNhanVien(tempData);
        }
    }

    const taiFileMau = async () => {
        dispatch(showLoadingScreen())
        try {
            if (form.getFieldValue('thangNam')?.$M != (null || undefined) && form.getFieldValue('thangNam')?.$y != (null || undefined)) {
                var response = await layMauLuongPhatSinh(form.getFieldValue('thangNam')?.$M + 1, form.getFieldValue('thangNam')?.$y);
                let link = document.createElement('a');
                link.download = `MauLuongPhatSinh.xlsx`;
                let blob = new Blob([response.data], { type: response.data.type });
                link.href = URL.createObjectURL(blob);
                link.click();
                URL.revokeObjectURL(link.href);
            }
            else {
                toast.error("Tháng năm không hợp lệ");
            }
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
        dispatch(hideLoadingScreen())
    }

    const onFinish = (values: any) => {
        setIsShowError(false);
        setConfirmModal({
            isShowModal: true,
            title: "Lưu công đoàn phí",
            content: <>Bạn có muốn <label>Lưu</label> công đoàn phí này không?</>,
            onSubmit: eventSave
        });
    };

    const handleChangeCurrencyFormSetting = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        if (e.target.value != "" && e.target.value != "-" && e.target.value != "-0") {
            const parsedValue = value.replace(/(?!^-)[^0-9]/g, '').trim().replace(/^(-)?0+/, '$1');
            var format = currencyFormat.formatMoney(parsedValue);
            form.setFieldsValue({ soTien: parsedValue, soTienStr: format });
        } else {
            form.setFieldsValue({ soTien: 0, soTienStr: e.target.value });
        }
    };

    const onFinishNV = (values: any) => {
        setIsEdditing(false);
        setRowIndex(-1);
        editingNV.mucThuNhap = values.mucThuNhap;
        editingNV.ghiChu = values.ghiChu;
        formNV.setFieldsValue({ mucThuNhapStr: "0", mucThuNhap: 0, ghiChu: "" });
    }

    const handleFileChange = (files: any) => {
        try {
            if (files && files.length > 0) {
                setFile(files[0]);
            }
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
    };

    const handleUpload = async () => {
        if (!file) {
            toast.error('Vui lòng chọn một tệp tin để tải lên.');
            return;
        }
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            const thangNamVal = form.getFieldValue('thangNam');
            const thoiGianStr = thangNamVal
                ? dayjs(thangNamVal).format('YYYY-MM-01')
                : dayjs().format('YYYY-MM-01');
            const response = await importFileCongDoanPhi(file, thoiGianStr);
            setDsNhanVien(response);
            toast.success("Import dữ liệu công đoàn phí thành công");
            setShowModal(false);
            setFile(null);
        } catch (error: any) {
            toast.error(typeof error === 'string' ? error : (error?.message || "Không thể import file. Vui lòng thử lại sau"));
        } finally {
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }
    };

    const eventSave = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values: {
            tenKTUH: string;
            thangNam: any;
            loaiKTUH: number;
            khoaDieuChinh: boolean;
            soTien: number;
            apDung: boolean;
        }) => {
            dispatch(showLoadingScreen())
            setIsLoading(true);
            try {
                var request = {
                    id: idKTUH,
                    ten: values.tenKTUH,
                    thang: values?.thangNam?.$M + 1,
                    nam: values?.thangNam?.$y,
                    loai: values.loaiKTUH ?? 0,
                    loaiUngHo: LOAI_CONG_DOAN_PHI,
                    khoaDieuChinh: trangThai === 1 ? 1 : 0,
                    dsNhanVien: dsNhanVien,
                    mucTrungBinh: values.soTien,
                    isApDungToanBo: isEffect,
                    ghiChu: ghiChu
                };
                var data = await luuKhenThuongUngHo(request);
                if (data != null && data > 0) {
                    toast.success("Lưu công đoàn phí thành công");
                    setIdKTUH(data);
                    if (idKTUH == 0) {
                        navigate(Links.Luong.ChiTietCongDoanPhi + "?id=" + data);
                    }
                    await layChiTiet(data);
                }
            } catch (error: any) {
                toast.error(error);
            }
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
    }

    const handleXacNhan = async () => {
        if (idKTUH <= 0 || isLoading) return;
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var values = await form.validateFields();
            var request = {
                id: idKTUH,
                ten: values.tenKTUH,
                thang: values?.thangNam?.$M + 1,
                nam: values?.thangNam?.$y,
                loai: values.loaiKTUH ?? 0,
                loaiUngHo: LOAI_CONG_DOAN_PHI,
                khoaDieuChinh: 1, // Xác nhận
                dsNhanVien: dsNhanVien,
                mucTrungBinh: values.soTien,
                isApDungToanBo: isEffect,
                ghiChu: ghiChu
            };
            var data = await luuKhenThuongUngHo(request);
            if (data != null && data > 0) {
                toast.success("Xác nhận công đoàn phí thành công");
                setShowModalXacNhan(false);
                await layChiTiet(data);
            }
        } catch (error: any) {
            toast.error(error?.message || error || "Có lỗi xảy ra");
        } finally {
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }
    };

    const layChiTiet = async (id: number) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var data = await layChiTietKhenThuongUngHo(id);
            if (data.id > 0) {
                if (data.thangNam) {
                    form.setFieldsValue({
                        id: data?.id,
                        tenKTUH: data?.ten,
                        loaiKTUH: data?.loai,
                        khoaDieuChinh: data?.khoaDieuChinh,
                        thangNam: data?.thangNam ? dayjs(dateCommon.formatDate(data?.thangNam), "Tháng MM/YYYY") : dayjs(dateCommon.formatDate(new Date()), "Tháng MM/YYYY"),
                        soTien: data?.mucTrungBinh ?? 0,
                        soTienStr: String(data?.mucTrungBinh ?? 0),
                        apDung: data?.isApDungToanBo,
                    });
                    let thang = (new Date(data?.thangNam))?.getMonth() + 1;
                    let nam = (new Date(data?.thangNam))?.getFullYear();
                    layDuLieu(thang, nam);
                    setDsNhanVien(data.dsNhanVien);
                    setTrangThai(data.khoaDieuChinh);
                    setGhiChu(data.ghiChu || '');
                    setLoaiKTUH(data.loai);
                    setThangNam(data.thangNam);
                    setIsEffect(data.isApDungToanBo);
                    setTitleIn(data.ten);
                    setIsDisable(true);
                }
            }
            setIsLoading(false);
        } catch (error: any) {
            toast.error("Thông tin công đoàn phí không tồn tại!");
            setIsLoading(false);
        }
        dispatch(hideLoadingScreen());
    }

    const layDuLieu = async (thang: number, nam: number) => {
        dispatch(showLoadingScreen())
        setIsLoading(true);
        try {
            var rs = await layDuLieuNhanVienVaMucLuong_Cong_PhuCap(thang, nam);
            setDataModalNV(rs);
        } catch (error: any) {
            toast.error(error);
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    };

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        if (e.target.value != "" && e.target.value != "-" && e.target.value != "-0") {
            const { value } = e.target;
            const parsedValue = value.replace(/(?!^-)[^0-9]/g, '').trim().replace(/^(-)?0+/, '$1');
            var format = currencyFormat.formatMoney(parsedValue);
            formNV.setFieldsValue({ mucThuNhapStr: format, mucThuNhap: parsedValue });
        }
        else {
            formNV.setFieldsValue({ mucThuNhapStr: e.target.value, mucThuNhap: 0 });
        }
    };

    const handleChangeGhiChu = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        formNV.setFieldsValue({ ghiChu: value });
    };

    const eventDelete = async () => {
        try {
            setShowModalDelete(false);
            dispatch(showLoadingScreen());
            await xoaLuongKhenThuongUngHo(idKTUH);
            navigate(Links.Luong.CongDoanPhi);
            toast.success("Xóa công đoàn phí thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const onChangeMucTien = (isEffectVal: boolean, dsNhanVienChange: Array<NhanVien_MucLuong_PhuCap>) => {
        if (isEffectVal) {
            let soTien = form.getFieldsValue(['soTien']).soTien;

            if (isEffectVal && soTien != null && dsNhanVienChange.length != 0) {
                const tiLe = +soTien || 0;
                const newArray = dsNhanVienChange.map((item) => {
                    const newItem = new NhanVien_MucLuong_PhuCap();
                    newItem.idNhanVien = item.idNhanVien;
                    newItem.tenChucVu = item.tenChucVu;
                    newItem.hoTen = item.hoTen;
                    newItem.mucLuongBHXH = item.mucLuongBHXH;
                    newItem.phuCapChucVu = item.phuCapChucVu;
                    newItem.maNhanVien = item.maNhanVien;
                    newItem.idNhom = item.idNhom;
                    newItem.tenDonVi = item.tenDonVi;
                    newItem.tenNhom = item.tenNhom;
                    newItem.idChucVu = item.idChucVu;
                    newItem.idDonVi = item.idDonVi;
                    newItem.ghiChu = item.ghiChu;
                    newItem.mucThuNhap = roundToInt(item.mucLuongBHXH * tiLe / 100) || 0;
                    return newItem;
                });
                newArray.forEach((item) => {
                    if (item.idNhanVien == 0) {
                        let sumMucTien = 0;
                        if (newArray.filter(x => x.idNhom == item.idNhom && x.idNhanVien != 0) != undefined) {
                            newArray.filter(x => x.idNhom == item.idNhom && x.idNhanVien != 0).forEach(x => { sumMucTien += x.mucThuNhap; });
                            item.mucThuNhap = sumMucTien;
                        }
                    };
                })
                setDsNhanVien(newArray);
            }
        }
    };

    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await XuatExcelLuongPhatSinh(idKTUH);
            let link = document.createElement('a');
            link.download = `CongDoanPhi.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
        }
        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        setIdKTUH(+id);
        if (id > 0) {
            layChiTiet(id);
        }
        else {
            form.setFieldsValue({
                thangNam: dayjs(dateCommon.formatDate(new Date(), "dd/MM/yyyy"), "Tháng MM/YYYY"),
                loaiKTUH: 0,
                khoaDieuChinh: false,
                soTien: 0,
                soTienStr: "0",
                ghiChu: ""
            })
            layDuLieu(new Date().getMonth() + 1, new Date().getFullYear());
        }
    }, []);

    useEffect(() => {
        if (reloadPage) {
            if (idKTUH > 0) {
                layChiTiet(idKTUH);
            }
            setReloadPage(false);
        }
    }, [reloadPage]);

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case 0: tag = (<Tag color="blue">Khởi tạo</Tag>); break;
        case 1: tag = (<Tag color="success">Đã xác nhận</Tag>); break;
    }

    return (
        <section>
            {showModalDelete && <ModalTextForm show
                title="Xoá công đoàn phí"
                handleClose={() => setShowModalDelete(false)}
                handleSave={eventDelete}>
                Xác nhận xóa công đoàn phí
            </ModalTextForm>}
            {showModalXacNhan && <ModalTextForm show
                title="Xác nhận công đoàn phí"
                handleClose={() => setShowModalXacNhan(false)}
                handleSave={handleXacNhan}>
                Bạn có chắc muốn <b>xác nhận</b> bảng công đoàn phí này không? Sau khi xác nhận sẽ khóa điều chỉnh.
            </ModalTextForm>}
            <ContentHeader title="Chi tiết công đoàn phí" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Form layout="vertical" onFinish={onFinish} validateMessages={validateMessages} form={form}>
                            <Tabs
                                tabBarExtraContent={
                                    <Space style={{ zIndex: 1, right: "25px", top: "120px" }}>
                                        <Button type="default" icon={<ArrowLeftOutlined rev="" />} onClick={() => { navigate(Links.Luong.CongDoanPhi) } }>
                                            Quay lại
                                        </Button>
                                        {(dsNhanVien != null && dsNhanVien.length > 0 && idKTUH > 0) &&
                                            <Button loading={isLoading} className="hrm-btn hrm-btn-success" icon={<DownloadOutlined rev="" />} onClick={handleExport}>Xuất excel</Button>
                                        }
                                        {/* {dsNhanVien.length > 0 && idKTUH > 0 && <Button onClick={() => { printLuong(); }} icon=<PrinterOutlined rev="" /> className="hrm-btn-print">In</Button>} */}
                                        {(idKTUH > 0 && trangThai == 0) && (
                                            <Button loading={isLoading} type="primary" style={{ background: '#52c41a', borderColor: '#52c41a' }} icon={<CheckOutlined rev="" />} onClick={() => setShowModalXacNhan(true)}>
                                                Xác nhận
                                            </Button>
                                        )}
                                        {(idKTUH == 0 || (idKTUH > 0 && trangThai == 0)) && <Button loading={isLoading} type="primary" icon={<SaveOutlined rev="" />} htmlType="submit">Lưu</Button>}
                                        {(idKTUH > 0 && trangThai == 0) && <Button loading={isLoading} type="primary" danger icon=<DeleteOutlined rev="" /> onClick={() => { setShowModalDelete(true) }}>Xóa</Button>}
                                    </Space>}
                                defaultActiveKey="1" items={[
                                    {
                                        key: "1",
                                        label: "Tùy chỉnh",
                                        children:
                                            <Row>
                                                <Col span="24" className="card card-body">
                                                    <Row gutter={48}>
                                                        <Col span="12">
                                                            <Form.Item label="Tên công đoàn phí" name="tenKTUH" rules={[{ required: true }]}>
                                                                <Input disabled={isDisable && trangThai == 1} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="6">
                                                            <Form.Item name="loaiKTUH" label="Loại phát sinh" rules={[{ required: true }]}>
                                                                <Select notFoundContent="Không có dữ liệu"
                                                                    onChange={(e) => { setLoaiKTUH(e); }}
                                                                    disabled={true}
                                                                    value={loaiKTUH}
                                                                    options={optionsLoaiKTUH}
                                                                    loading={isLoading}
                                                                    placeholder="Loại phát sinh" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="6">
                                                            <Form.Item<FieldKPICaNhan> name="thangNam" label="Tháng" rules={[{ required: true }]}>
                                                                <DatePicker
                                                                    changeOnBlur={true}
                                                                    clearIcon={false}
                                                                    style={{ width: "100%" }}
                                                                    placeholder="Tháng"
                                                                    picker="month"
                                                                    format={thangNamFormat}
                                                                    disabled={isDisable && trangThai == 1}
                                                                    onChange={(e, dateString) => {
                                                                        layDuLieu((e?.get('month') != undefined) ? + e?.get('month') + 1 : new Date().getMonth() + 1, e?.get('year') ?? new Date().getFullYear());
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={48}>
                                                        <Col span="6">
                                                            <Form.Item label={
                                                                <span>
                                                                    Tỉ lệ đóng công đoàn phí&nbsp;
                                                                    <Tooltip title="Nhập tỉ lệ phần trăm, ví dụ nhập 0.5 hoặc 1 (tương đương 0.5% hoặc 1% mức lương BHXH)">
                                                                        <span style={{ color: '#1890ff', cursor: 'pointer' }}>(?)</span>
                                                                    </Tooltip>
                                                                </span>
                                                            } name="soTienStr" rules={[{ required: true }]}>
                                                                <Input
                                                                    disabled={isDisable && trangThai == 1}
                                                                    suffix="%"
                                                                    type="number"
                                                                    step="0.01"
                                                                    min={0}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        form.setFieldsValue({ soTien: val, soTienStr: val });
                                                                        onChangeMucTien(isEffect, dsNhanVien);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item hidden name="soTien"><Input /></Form.Item>
                                                        </Col>
                                                        <Col span="4">
                                                            <Form.Item name="khoaDieuChinh" label=" " valuePropName="checked">
                                                                <Checkbox disabled={isDisable && trangThai == 1}>Khóa điều chỉnh</Checkbox>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="4">
                                                            <Form.Item name="apDung" label=" ">
                                                                <Checkbox disabled={isDisable && trangThai == 1} checked={isEffect} onChange={(e) => {
                                                                    setIsEffect(e.target.checked);
                                                                    onChangeMucTien(e.target.checked, dsNhanVien);
                                                                }}>
                                                                    Áp dụng toàn bộ
                                                                </Checkbox>
                                                            </Form.Item>
                                                        </Col>
                                                        {idKTUH > 0 && (1 >= trangThai && trangThai >= 0) &&
                                                            <Col span="4">
                                                                <Form.Item label="Trạng thái">
                                                                    <label>{tag}</label>
                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </Col>
                                            </Row>
                                    }
                                ]}
                            />
                        </Form>
                    </div>
                </Col>
            </Row>
            {idKTUH > 0 && (
                <Row>
                    <Col span="24">
                        <DinhKemFilePDF idLuongKhenThuongUngHo={idKTUH} />
                    </Col>
                </Row>
            )}
            <Row className="mb-3">
                <Col span="24">
                    <div className="card card-body" style={{ borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: '15px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Ghi chú</div>
                        {(trangThai === 0 || idKTUH === 0) ? (
                            <Input.TextArea
                                rows={3}
                                placeholder="Nhập ghi chú cho bảng công đoàn phí..."
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        ) : (
                            <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                                {ghiChu || 'Không có ghi chú'}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            {
                <Row>
                    <Col span="24">
                        <div className="card-outline">
                            <Form form={formNV} onFinish={onFinishNV}>
                                <Tabs
                                    tabBarExtraContent=
                                    {(idKTUH == 0 || (idKTUH > 0 && trangThai == 0)) &&
                                        <Space style={{ zIndex: 1, right: "25px", top: "120px" }}>
                                            <Button onClick={() => setShowModal(true)} type="primary" loading={isLoading} icon={<UploadOutlined rev="" />}>Import file</Button>
                                            <Button className="hrm-btn-success" onClick={taiFileMau} loading={isLoading} icon=<DownloadOutlined rev="" />>Tải file mẫu</Button>
                                            <Button className="hrm-btn hrm-btn-warning" onClick={() => { setShowModalDSNV(true); }} icon={<PlusOutlined rev="" />}>Thêm mới</Button>
                                        </Space>
                                    }
                                    defaultActiveKey="1" items={[
                                        {
                                            key: '1',
                                            label: 'Danh sách nhân viên',
                                            children:
                                                <Table
                                                    locale={{ emptyText: "Không có dữ liệu" }}
                                                    dataSource={(dsNhanVien || []).map((value: any, index: any) => { const item = { key: index, ...value }; return item; })}
                                                    pagination={false}
                                                    sticky
                                                    rowClassName={(record, index) => {
                                                        if (record.idNhanVien == 0) return "bold-row-summary";
                                                        return "";
                                                    }}
                                                    bordered
                                                    summary={pageData => {
                                                        var totalMucLuongThucNhan = 0;
                                                        var totalMucTien = 0;
                                                        pageData.forEach(({ mucLuongBHXH, mucThuNhap, idNhanVien }) => {
                                                            if (idNhanVien != 0) {
                                                                totalMucLuongThucNhan += mucLuongBHXH;
                                                                totalMucTien += mucThuNhap;
                                                            }
                                                        });
                                                        return (
                                                            <>
                                                                <Table.Summary.Row>
                                                                    <Table.Summary.Cell key="summary_TongCong" index={0} colSpan={2} align="left"><label>Tổng cộng</label></Table.Summary.Cell>
                                                                    <Table.Summary.Cell key="summary_TotalMLTN" index={3} align="right"><label>{formatVND(totalMucLuongThucNhan) || "-"}</label></Table.Summary.Cell>
                                                                    <Table.Summary.Cell key="summary_TotalMT" index={5} align="right"><label>{formatVND(totalMucTien) || "-"}</label></Table.Summary.Cell>
                                                                    <Table.Summary.Cell key="ghiChu" index={6} align="left"><label></label></Table.Summary.Cell>
                                                                    {!(isDisable && trangThai == 1) && <Table.Summary.Cell key="hanhDong_Sua_Xoa" index={7}><label> </label></Table.Summary.Cell>}
                                                                </Table.Summary.Row>
                                                            </>
                                                        );
                                                    }}
                                                >
                                                    <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                                    <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                                    <Column title="Tiền lương đóng BHXH" className="custom-column" dataIndex="mucLuongBHXH" key="mucLuongBHXH" render={(value) => <>{formatVND(value)}</>} />
                                                    <Column className="custom-column" title="Mức tiền"
                                                        key="mucThuNhap"
                                                        render={(value: NhanVien_MucLuong_PhuCap, record, index) => (
                                                            index === rowIndex ?
                                                                <>
                                                                    <Form.Item name="mucThuNhapStr" rules={[{ required: true, message: "Mức tiền bắt buộc nhập" }]}>
                                                                        <Input prefix="₫ "
                                                                            onChange={(e) => {
                                                                                handleChangeCurrency(e);
                                                                                if (e.target.value != "" && e.target.value != "-" && e.target.value != "-0") {
                                                                                    value.mucThuNhap = +e.target.value.replace(/(?!^-)[^0-9]/g, '').trim().replace(/^(-)?0+/, '$1');
                                                                                    dsNhanVien[index].mucThuNhap = value.mucThuNhap;
                                                                                    var rowTotal = dsNhanVien.find(x => x.idNhanVien == 0 && x.idNhom == dsNhanVien[index].idNhom);
                                                                                    if (rowTotal != undefined) {
                                                                                        rowTotal.mucThuNhap = dsNhanVien?.filter(x => x.idNhanVien != 0 && x.idNhom == dsNhanVien[index].idNhom)?.map(x => x.mucThuNhap)?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                                                                                    }
                                                                                    setDsNhanVien([...dsNhanVien]);
                                                                                }
                                                                                else {
                                                                                    value.mucThuNhap = 0;
                                                                                    dsNhanVien[index].mucThuNhap = value.mucThuNhap;
                                                                                    var rowTotal = dsNhanVien.find(x => x.idNhanVien == 0 && x.idNhom == dsNhanVien[index].idNhom);
                                                                                    if (rowTotal != undefined) {
                                                                                        rowTotal.mucThuNhap = dsNhanVien?.filter(x => x.idNhanVien != 0 && x.idNhom == dsNhanVien[index].idNhom)?.map(x => x.mucThuNhap)?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                                                                                    }
                                                                                    setDsNhanVien([...dsNhanVien]);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                    <Form.Item hidden name="mucThuNhap"><Input /></Form.Item>
                                                                </>
                                                                :
                                                                <>{formatVND(value.mucThuNhap)}</>
                                                        )}
                                                    />
                                                    <Column title="Ghi Chú" dataIndex="ghiChu" key="ghiChu"
                                                        render={(value, record, index) => (
                                                            index === rowIndex ? (
                                                                <Form.Item name={`ghiChu[${index}]`} initialValue={value}>
                                                                    <Input onChange={(e) => {
                                                                        handleChangeGhiChu(e);
                                                                        const newValue = e.target.value;
                                                                        setDsNhanVien(prevDsNhanVien => {
                                                                            const updatedDsNhanVien = [...prevDsNhanVien];
                                                                            updatedDsNhanVien[index] = { ...updatedDsNhanVien[index], ghiChu: newValue };
                                                                            return updatedDsNhanVien;
                                                                        });
                                                                    }} />
                                                                </Form.Item>
                                                            ) : (
                                                                <span>{value}</span>
                                                            )
                                                        )}
                                                    />
                                                    {!(isDisable && trangThai == 1) &&
                                                        <Column className="text-center" title="Hành động" key="action"
                                                            render={(value: NhanVien_MucLuong_PhuCap, record, index) => (
                                                                <>
                                                                    {value.idNhanVien != 0 &&
                                                                        <Space>
                                                                            {index === rowIndex && isEdditing ? null :
                                                                                <Button
                                                                                    disabled={idKTUH > 0 && trangThai == 1}
                                                                                    type="primary"
                                                                                    icon={<EditOutlined rev="" />}
                                                                                    size={"small"}
                                                                                    onClick={() => {
                                                                                        setIsEdditing(true);
                                                                                        setEditingNV(value);
                                                                                        setRowIndex(index);
                                                                                        formNV.setFieldsValue({
                                                                                            mucLuongHDLD: value.mucLuongBHXH,
                                                                                            phuCapChucVu: value.phuCapChucVu,
                                                                                            mucThuNhap: value?.mucThuNhap,
                                                                                            mucThuNhapStr: currencyFormat.formatMoney(value?.mucThuNhap?.toString()?.replace(/(?!^-)[^0-9]/g, '').trim().replace(/^(-)?0+/, '$1')),
                                                                                            ghiChu: value?.ghiChu
                                                                                        });
                                                                                    }}>Sửa</Button>
                                                                            }
                                                                            {index === rowIndex && isEdditing && <Button className="btn-success" type="primary" size={"small"} icon=<SaveOutlined rev="" /> htmlType='submit'>Lưu</Button>}
                                                                            <Button type="primary" disabled={(idKTUH > 0) && (trangThai == 1)} icon={<DeleteOutlined rev="" />} size={"small"} danger
                                                                                onClick={() => {
                                                                                    onChangeDanhSachNhanVienTableModal(value, false);
                                                                                    setRowIndex(-1);
                                                                                }}>Xóa</Button>
                                                                        </Space>
                                                                    }
                                                                </>
                                                            )}
                                                        />}
                                                </Table>
                                        },
                                    ]}>
                                </Tabs>
                            </Form>
                        </div>
                    </Col>
                </Row>
            }
            <Modal
                title={
                    <Space>
                        <FileExcelOutlined style={{ color: '#217346', fontSize: 18 }} />
                        <span>Import dữ liệu công đoàn phí từ file Excel</span>
                    </Space>
                }
                open={showModal}
                onCancel={() => {
                    if (!isLoading) {
                        setShowModal(false);
                        setFile(null);
                    }
                }}
                footer={[
                    <Button
                        key="back"
                        disabled={isLoading}
                        onClick={() => {
                            setShowModal(false);
                            setFile(null);
                        }}
                    >
                        Hủy
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={isLoading}
                        disabled={!file}
                        icon={<UploadOutlined rev="" />}
                        onClick={handleUpload}
                    >
                        Tải lên
                    </Button>,
                ]}
                destroyOnClose
                centered
            >
                <div style={{ padding: '8px 0' }}>
                    <Dropzone
                        maxFiles={1}
                        multiple={false}
                        accept={{
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                            'application/vnd.ms-excel': ['.xls'],
                        }}
                        onDrop={handleFileChange}
                    >
                        {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                                {...getRootProps()}
                                className="hrm-dropzone-uploadfile"
                                style={{
                                    padding: '28px 16px',
                                    background: isDragActive ? '#e6f4ff' : '#fafafa',
                                    borderColor: isDragActive ? '#1677ff' : file ? '#28a745' : '#d9d9d9',
                                    borderRadius: 8,
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined rev="" style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#1677ff', margin: 0 }}>
                                            Thả tệp Excel vào đây...
                                        </p>
                                    </div>
                                ) : file ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <FileExcelOutlined style={{ color: '#217346', fontSize: 40 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 600, color: '#262626', margin: '0 0 4px 0', wordBreak: 'break-all' }}>
                                            {file.name}
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: '0 0 8px 0' }}>
                                            Kích thước: {(file.size / 1024).toFixed(1)} KB
                                        </p>
                                        <Button
                                            size="small"
                                            danger
                                            disabled={isLoading}
                                            icon={<DeleteOutlined rev="" />}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setFile(null);
                                            }}
                                        >
                                            Chọn tệp khác
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined rev="" style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#262626', margin: '0 0 4px 0' }}>
                                            Nhấp hoặc kéo thả tệp Excel vào đây để tải lên
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: 0 }}>
                                            Hỗ trợ định dạng tệp .xlsx, .xls
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                    </Dropzone>
                </div>
            </Modal>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => { confirmModal.onSubmit(); setConfirmModal({ isShowModal: false }); }}
            >
                {confirmModal.content}
            </ModalTextForm>
            {showModalDSNV ? <DanhSachMucLuongVaPhuCapTheoNhanVienTableModal
                data={dataModalNV}
                checklist={dsNhanVien}
                hide={() => setShowModalDSNV(false)}
                onChange={onChangeDanhSachNhanVienTableModal}
                onChangeCheckAll={(e) => {
                    if (e) {
                        if (isEffect) {
                            onChangeMucTien(isEffect, dataModalNV)
                        }
                        else {
                            setDsNhanVien(dataModalNV);
                        }
                    }
                    else {
                        setDsNhanVien([]);
                    }
                }} /> : null}
            {dsNhanVien.length > 0 && idKTUH > 0 &&
                <section style={{ display: 'none' }}>
                    <PrintPage ref={componentRef}>
                        <InChiTietKhenThuongUngHo title={titleIn} duLieu={dsNhanVien} thang={thangNam}></InChiTietKhenThuongUngHo>
                    </PrintPage>
                </section>
            }
        </section>
    );
};

export default CongDoanPhi;
